import React from 'react';

import { TwoColumnsTableComponent } from 'baseComponents/TwoColumnsTableComponent';

import './UCS2Table.scss';
import { convertDataToReferenceTable } from 'helpers/compose-message';

interface Props {
  data: any;
}

export const UCS2Table: React.FC<Props> = (props) => {
  const convertedDataUCS = props.data
    ? convertDataToReferenceTable(props.data)
    : [];
  return (
    <div className='reference-table-wrapper'>
      <TwoColumnsTableComponent items={convertedDataUCS} />
    </div>
  );
};
